import { render } from "./tegsoft-privacy.vue?vue&type=template&id=24010cf0&scoped=true"
import script from "./tegsoft-privacy.vue?vue&type=script&lang=js"
export * from "./tegsoft-privacy.vue?vue&type=script&lang=js"

import "./tegsoft-privacy.vue?vue&type=style&index=0&id=24010cf0&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24010cf0"]])

export default __exports__